import type { FunctionComponent } from 'react'
import React, { useState } from 'react'
import { Jumplinks as SBJumplinks } from '@which/seatbelt'

import { useFeatureIsOn } from '@growthbook/growthbook-react'

import { JumpLinkHeaderBar } from '../../../../shared/components/JumpLinkHeaderBar'
import type { ReviewsAdviceSingleArticleData } from '../../ReviewsAdviceSinglePage'

type Props = {
  handleOnClick?: () => void
  showJumpLinkBar?: boolean
  links: ReviewsAdviceSingleArticleData['jumpLinks']
}

export const JumpLinks: FunctionComponent<Props> = ({ handleOnClick, showJumpLinkBar, links }) => {
  const [jumpLinkBarHeight, setJumpLinkBarHeight] = useState(0)
  const isStickyHeaderEnabled = useFeatureIsOn('WHC-1475-sticky-header')

  if (links?.length <= 3) {
    return null
  }

  const scrollTo = (slug: string) => {
    const header = document.getElementById(slug)

    if (header) {
      const scrollPos = window.scrollY + header.getBoundingClientRect().top

      window.scrollTo({
        top: scrollPos - jumpLinkBarHeight - (isStickyHeaderEnabled ? 120 : 0),
        behavior: 'smooth',
      })
      window.history.pushState(null, '', `#${slug}`)
    }
  }

  const RenderLinks = () => (
    <div className="mb-5">
      <SBJumplinks
        items={links?.map(({ name, slug }) => ({
          text: name,
          path: `#${slug}`,
          onClick: (event: MouseEvent): void => {
            event.preventDefault()

            if (handleOnClick) {
              handleOnClick()

              setTimeout(() => {
                scrollTo(slug)
              }, 0)
            } else {
              scrollTo(slug)
            }
          },
        }))}
      />
    </div>
  )

  return (
    <>
      {showJumpLinkBar ? (
        <JumpLinkHeaderBar jumpLinkBarHeightCallback={setJumpLinkBarHeight} links={links}>
          <RenderLinks />
        </JumpLinkHeaderBar>
      ) : (
        <RenderLinks />
      )}
    </>
  )
}
